exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.section-title {\n    color: #7367f0;\n    border-bottom: 2px solid #7367f0;\n    padding-bottom: 8px;\n    margin-bottom: 20px;\n    font-weight: 600;\n}\n.text-muted {\n    margin-top: 5px;\n    margin-bottom: 0;\n}\n", ""]);

// exports
